import { useEditor } from "../../EditorContext";


function SubformInteger({control, formStructure}){

  const { changeFieldType, updateFieldUiSchema, updateFieldSchema, setEditingElement } = useEditor()

  return(
    <div className="form">
      <div className="row mb-3">
        <label className="col-sm-2 col-form-label">максимальное значение</label>
        <div className="col-sm-2">
          <input
            id="maximum"
            type="number"
            className="form-control"
            value={control.schemaProps.maximum ?? ''}
            onChange={(e) => updateFieldSchema(formStructure, control.id, e.target)}
            placeholder="введите число"
          />
        </div>
      </div>
      <div className="row mb-3">
        <label className="col-sm-2 col-form-label">минимальное значение</label>
        <div className="col-sm-2">
          <input
            id="minimum"
            type="number"
            className="form-control"
            value={control.schemaProps.minimum ?? ''}
            onChange={(e) => updateFieldSchema(formStructure, control.id, e.target)}
            placeholder="введите число"
          />
        </div>
      </div>       
    </div>
  )
}

export default SubformInteger